import { useState } from "react";
import { LuDownload, LuLoader2 } from "react-icons/lu";
import { btnSecondary } from "./styles";

/** "Export 1,234 rows" button for list pages; shows a spinner while the file downloads */
const ExportButton = ({
  total,
  noun = "rows",
  disabled,
  onExport,
}: {
  total?: number;
  noun?: string;
  disabled?: boolean;
  onExport: () => Promise<unknown>;
}) => {
  const [busy, setBusy] = useState(false);
  const label =
    total === undefined ? "Export" : `Export ${total.toLocaleString()} ${total === 1 ? noun.replace(/s$/, "") : noun}`;

  return (
    <button
      type="button"
      disabled={disabled || busy || total === 0}
      onClick={async () => {
        setBusy(true);
        try {
          await onExport();
        } finally {
          setBusy(false);
        }
      }}
      className={`${btnSecondary} inline-flex items-center gap-2`}
      title="Downloads every row matching the current tab and filters as a CSV file"
    >
      {busy ? <LuLoader2 className="h-4 w-4 animate-spin" aria-hidden /> : <LuDownload className="h-4 w-4" aria-hidden />}
      {busy ? "Preparing file" : label}
    </button>
  );
};

export default ExportButton;
